import { CatButton } from '@blocks-react/components/Button';
import { CatIconFilterLines } from '@blocks-react/components/Icons/FilterLines';
import { CatBadge } from '@blocks-react/components/Badge';
import { useDrawer } from '../../../hooks/useDrawer';

interface DealerLocatorFilterButtonProps {
  filtersDrawer: ReturnType<typeof useDrawer>;
  children: React.JSX.Element | string;
  filtersCounter?: number;
  isDisabled?: boolean;
}

export const DealerLocatorFilterButton = ({
  children,
  filtersDrawer,
  filtersCounter,
  isDisabled
}: DealerLocatorFilterButtonProps) => (
  <span className="me-0 ms-auto">
    <CatButton {...filtersDrawer.initiatorProps} disabled={isDisabled}>
      <CatIconFilterLines slot="before" />
      {children}
      {!!filtersCounter && (
        <CatBadge
          className="ms-1"
          data-testid="dealer-locator-filter-button-badge"
          variant="contrast"
          text={filtersCounter?.toString()}
        />
      )}
    </CatButton>
  </span>
);
